<template>
  <div>
    <b-card title="Datos del usuario">
      <b-row>
        <b-col md="6">
          <b-col>
            <b-form-group
              label="ID SmartAgro"
              label-for="user_id"
            >
              <b-form-input
                id="user_id"
                v-model="user.user_id"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Nombre"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="user.name"
              />
            </b-form-group>
          </b-col>
        </b-col>
        <b-col md="6">
          <b-col>
            <b-form-group
              label="DNI"
              label-for="dni"
            >
              <b-form-input
                id="dni"
                v-model="user.dni"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Estado"
              label-for="status"
            >
              <v-select
                id="status"
                v-model="user.status"
                :options="optionsActivo"
                :clearable="false"
                :reduce="item => item.key"
              />
            </b-form-group>
          </b-col>
        </b-col>
      </b-row>
      <b-row>
        <!-- submit and reset -->
        <b-col>
          <div>
            <b-button variant="primary" @click="sendData">
              <feather-icon icon="SaveIcon" class="mr-50" />
              <span class="align-middle">Guardar cambios</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import axiosIns from '../../../../../../libs/axios'
import moment from 'moment'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
  },

  data() {
    return {
      isLoading: false,
      user: {},
      optionsSiNo: [
        {
          key: true,
          label: 'Sí',
        },
        {
          key: false,
          label: 'No',
        },
      ],
      optionsActivo: [
        {
          key: true,
          label: 'Activo',
        },
        {
          key: false,
          label: 'Inactivo',
        },
      ],
    }
  },
  created() {
  },
  methods: {
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const { id } = jsonUserData
      return id
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    async sendData() {
      this.isLoading = true
      try {
        const response = await axiosIns.post(`/nomina/boss_user/`, this.user)
        if (response && response.status === 201) {
          this.isLoading = false
          this.fetchData()
          this.$swal({
            icon: 'success',
            title: '¡Guardado!',
            text: 'La información ha sido registrada',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        } else {
          this.printErrorModal('Error en el servidor')
        }
      } catch (error) {
        console.error('Error:', error)
        this.isLoading = false
      }
    },
  },
}
</script>
